import React, {PropsWithChildren} from 'react';
import Card from './common/Card';

interface GridCardProps {
    imgSrc?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

function GridCard(props: PropsWithChildren<GridCardProps>): JSX.Element {
    const {imgSrc, children, onClick} = props;

    return (
        <Card
            modifiers={['grid']}
            header={
                <div className="c-card__header_img u-pointer" onClick={onClick}>
                    {imgSrc ? <img src={imgSrc} alt="" /> : null}
                </div>
            }
        >
            {children}
        </Card>
    );
}

export default GridCard;
